import axios from 'axios';

// Create axios instance with base configuration
const apiClient = axios.create({
  baseURL: 'https://resume-chatbot-6enc.onrender.com',
  timeout: 10000, // 10 seconds timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

// Response interceptor to handle common response format
apiClient.interceptors.response.use(
  (response) => {
    const { data, message, code } = response.data;
    
    if (code === 200) {
      return data;
    } else {
      console.error('API Error:', { message, code, data });
      return undefined;
    }
  },
  (error) => {
    console.error('Network Error:', error.message);
    return undefined;
  }
);

// Server active/inactive check endpoint
export const checkServerActive = async () => {
  try {
    const response = await apiClient.get('/api');
    return response;
  } catch (error) {
    console.error('Server is Inactive:', error);
    return undefined;
  }
};

// Health check endpoint
export const checkHealth = async () => {
  try {
    const response = await apiClient.get('/api/health');
    return response;
  } catch (error) {
    console.error('Health check failed:', error);
    return undefined;
  }
};

// Query endpoint
export const sendQuery = async (queryData) => {
  try {
    const response = await apiClient.post('/api/query', queryData);
    return response;
  } catch (error) {
    console.error('Query request failed:', error);
    return undefined;
  }
};

// Session info endpoint
export const getSessionInfo = async () => {
  try {
    const response = await apiClient.get('/api/session-info');
    return response;
  } catch (error) {
    console.error('Session info request failed:', error);
    return undefined;
  }
};

// Clear history endpoint
export const clearHistory = async () => {
  try {
    const response = await apiClient.delete('/clear-history');
    return response;
  } catch (error) {
    console.error('Clear history request failed:', error);
    return undefined;
  }
};

export default apiClient;
